import { makeStyles } from 'tss-react/mui';

export default makeStyles()(theme => ({
  dialogRoot: {
    width: theme.spacing(100),
    maxWidth: '95vw'
  },
  closeIcon: {
    width: '24px',
    height: '24px',
    marginTop: '-4px',
    flexShrink: 0
  },
  header: {
    color: theme.palette.primary.main,
    marginTop: theme.spacing(1),
    '& h2': {
      fontWeight: 400,
      fontSize: '1.5rem'
    }
  },
  paymentInfoBox: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2.5),
    backgroundColor: theme.palette.grey[50],
    borderRadius: theme.spacing(1),
    border: `1px solid ${theme.palette.grey[200]}`,
    '& .MuiTypography-root': {
      fontSize: '1rem',
      marginBottom: theme.spacing(0.5)
    }
  },
  selectedInvoicesBox: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  selectedInvoicesTitle: {
    fontSize: '1.2rem',
    fontWeight: 500,
    marginBottom: theme.spacing(2),
    color: theme.palette.text.primary
  },
  invoiceItem: {
    marginBottom: theme.spacing(1.5),
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
    '& .MuiTypography-root': {
      fontSize: '0.95rem',
      marginBottom: theme.spacing(0.5)
    }
  },
  summaryBox: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2.5),
    backgroundColor: theme.palette.grey[100],
    borderRadius: theme.spacing(1),
    border: `1px solid ${theme.palette.grey[200]}`,
    '& .MuiTypography-root': {
      fontSize: '1rem',
      marginBottom: theme.spacing(0.5)
    }
  },
  warningAlert: {
    marginTop: theme.spacing(2),
    '& .MuiAlert-message': {
      fontSize: '0.95rem'
    }
  }
}));
